import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useLocation, useSearchParams } from "react-router";
import { fetchDashboardSummaryQuery } from "../../behavior/api/viewer";
import { ArticleLinkCard, HubertTip, YourInterviewsTable } from "../../components/common";
import { LearnWithHubert, YourCareer } from "../../components/dashboard";
import InterviewCompletedModal from "../../components/dashboard/InterviewCompletedModal";
import LatestJobPostings from "../../components/dashboard/latestJobPostings";
import NewCandidateModalPopup from "../../components/dashboard/NewCandidateModalPopup";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import { PageState } from "../../constants";
import type Application from "../../types/application";
import "./Dashboard.css";

const Dashboard = () => {
    const { t } = useTranslation();
    const { data, isLoading: loading } = useQuery({
        queryKey: ["viewer", "dashboard-summary"],
        queryFn: fetchDashboardSummaryQuery(),
    });
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const openNewCandidateModal = location.state?.emailVerified as boolean;
    const openInterviewCompletedModal = searchParams.get("state") === PageState.INTERVIEW_COMPLETED;

    if (openNewCandidateModal) {
        window.history.replaceState({}, "");
    }

    const recentInterview = (data?.recentInterview ?? undefined) as Application | undefined;
    const todoInterview = (data?.todoInterview ?? undefined) as Application | undefined;

    return (
        <>
            <Header type="LoggedIn" />
            <div className="dashboard-wrapper">
                <YourCareer recentInterview={recentInterview} todoInterview={todoInterview} loading={loading} />
                <YourInterviewsTable forDashboard />
                <LatestJobPostings />
                <LearnWithHubert />
                <div className="tip-and-guide-wrapper">
                    <div className="section">
                        <HubertTip
                            title={t("Dashboard.HubertTip.Title")}
                            subtitle={t("Dashboard.HubertTip.Subtitle")}
                            description={t("Dashboard.HubertTip.Description")}
                            btnText={t("Dashboard.HubertTip.ButtonText_ReadMoreTips")}
                        />
                    </div>
                    <div className="section">
                        <ArticleLinkCard />
                    </div>
                </div>
            </div>
            <Footer />
            {openNewCandidateModal && <NewCandidateModalPopup />}
            {openInterviewCompletedModal && <InterviewCompletedModal />}
        </>
    );
};

export default Dashboard;
